import { Toast, ToastDescription } from '@gluestack-ui/themed';

import { globalToast } from '../../provider/toastProvider';

export default function successToast(message) {
  console.info('Success toast: ', message);

  globalToast()?.show({
    placement: 'top',
    render: ({ id }) => {
      const toastId = 'toast-' + id;
      return (
        <Toast nativeID={toastId} action="success" variant="accent">
          <ToastDescription>{message}</ToastDescription>
        </Toast>
      );
    },
  });
}
